import { motion } from "framer-motion";
import { MaskLine } from "./Reveal";

// Reusable page hero with kinetic masked title
export default function PageHeader({ overline, title, highlight, subtitle, testid }) {
  return (
    <section className="pt-36 md:pt-44 pb-12 md:pb-16 bg-white overflow-hidden" data-testid={testid}>
      <div className="container-x">
        {overline && (
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="font-heading font-bold uppercase tracking-[0.2em] text-sm text-[#0033A2] mb-5"
          >
            {overline}
          </motion.p>
        )}
        <h1 className="font-heading font-black tracking-tighter leading-[0.92] text-[13vw] md:text-[7vw]">
          <MaskLine delay={0.1}>{title}</MaskLine>
          {highlight && (
            <MaskLine delay={0.22}>
              <span className="text-[#0033A2]">{highlight}</span>
            </MaskLine>
          )}
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="mt-6 max-w-2xl text-lg md:text-xl font-medium text-black/65 leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
